import { render, staticRenderFns } from "./livegod.vue?vue&type=template&id=4b058785&scoped=true"
import script from "./livegod.vue?vue&type=script&lang=js"
export * from "./livegod.vue?vue&type=script&lang=js"
import style0 from "./livegod.vue?vue&type=style&index=0&id=4b058785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b058785",
  null
  
)

export default component.exports